/**
 * GiftTiers — reliable B2B prices in cart-drawer (main sales funnel).
 * WSAIO often fails to rewrite drawer prices when gifts are present.
 * We apply customer discount_percent from GiftTierContext as a display fallback.
 */
(function GiftTiersDrawerB2bPrices() {
  "use strict";

  if (window.__GiftTiersDrawerB2bPricesBooted) return;
  window.__GiftTiersDrawerB2bPricesBooted = true;

  function getPct() {
    var ctx = window.GiftTierContext || {};
    if (
      window.GiftTiersCartValue &&
      typeof window.GiftTiersCartValue.getB2bDiscountPercent === "function"
    ) {
      return window.GiftTiersCartValue.getB2bDiscountPercent(ctx) || 0;
    }
    return Number(ctx.b2bDiscountPercent || 0) || 0;
  }

  function formatCents(cents) {
    cents = Math.max(0, Math.round(Number(cents) || 0));
    try {
      if (window.Shopify && typeof Shopify.formatMoney === "function") {
        var fmt =
          (window.theme &&
            theme.settings &&
            (theme.settings.money_format || theme.settings.money_with_currency_format)) ||
          "{{amount}} €";
        return Shopify.formatMoney(cents, fmt);
      }
    } catch (_) {}
    try {
      return new Intl.NumberFormat("es-ES", {
        style: "currency",
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR",
      }).format(cents / 100);
    } catch (_) {
      return (cents / 100).toFixed(2) + " €";
    }
  }

  function discountedCents(listCents, pct) {
    if (!(pct > 0)) return listCents;
    return Math.round(listCents * (100 - pct) / 100);
  }

  function paintPriceEl(el, listCents, saleCents) {
    if (!el) return;
    if (saleCents < listCents) {
      el.innerHTML =
        "<del><span class=\"amount\">" +
        formatCents(listCents) +
        "</span></del> <ins><span class=\"amount\">" +
        formatCents(saleCents) +
        "</span></ins>";
    } else {
      el.innerHTML = "<ins><span class=\"amount\">" + formatCents(listCents) + "</span></ins>";
    }
  }

  function applyDrawerPrices() {
    var drawer = document.getElementById("Cart-Drawer");
    if (!drawer) return;

    var pct = getPct();
    if (!(pct > 0)) return;

    var totalSale = 0;
    var items = drawer.querySelectorAll(".product-cart-item[data-gt-line-cents]");
    items.forEach(function (row) {
      var list = Number(row.getAttribute("data-gt-line-cents") || 0);
      var isGift = row.getAttribute("data-gt-is-gift") === "1";
      var finalAttr = Number(row.getAttribute("data-gt-final-cents") || list);
      var sale = isGift || finalAttr === 0 ? finalAttr : discountedCents(list, pct);
      totalSale += sale;

      row.querySelectorAll(".drawer_price").forEach(function (priceEl) {
        if (isGift || finalAttr === 0) {
          // Keep gift at 0 / already-final
          if (finalAttr === 0) {
            priceEl.innerHTML =
              "<ins><span class=\"amount\">" + formatCents(0) + "</span></ins>";
          }
          return;
        }
        paintPriceEl(priceEl, list, sale);
      });
      row.setAttribute("data-gt-b2b-applied", "1");
    });

    // Checkout CTA + hidden hulkapps total backups inside drawer
    drawer.querySelectorAll("[data-hulkapps-cart-total], [data-gt-cart-total]").forEach(function (el) {
      el.textContent = formatCents(totalSale);
      el.setAttribute("data-gt-b2b-applied", "1");
    });
  }

  var timer = null;
  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(applyDrawerPrices, typeof ms === "number" ? ms : 80);
  }

  function boot() {
    schedule(200);
    schedule(1200); // after WSAIO's typical delay — we overwrite if still list price
    [
      "cart-drawer:open",
      "cart:refresh",
      "cart:item-added",
      "line-item:change:end",
      "gifttiers:loyalty-claimed",
    ].forEach(function (evt) {
      document.addEventListener(evt, function () {
        schedule(120);
        schedule(600);
      });
    });

    var drawer = document.getElementById("Cart-Drawer");
    if (drawer && typeof MutationObserver !== "undefined") {
      var moTimer = null;
      new MutationObserver(function () {
        clearTimeout(moTimer);
        moTimer = setTimeout(applyDrawerPrices, 100);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  window.GiftTiersDrawerB2bPrices = { apply: applyDrawerPrices };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
